var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddAPhotoFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 997q-37.813 0-64.406-26.594Q18 943.812 18 906V410q0-36.588 26.594-64.294Q71.187 318 109 318h133l83-97h258v153h126v139h153v393q0 37.812-27.706 64.406Q806.588 997 770 997H109Zm331.294-168Q512 829 561 780t49-121q0-73-49-121t-121-48q-73 0-121 48.294t-48 121Q271 731 319.294 780t121 49Zm-.062-57Q391 772 359.5 739.81T328 659.5q0-49.12 31.563-80.81 31.564-31.69 80.5-31.69Q488 547 520.5 578.69T553 659.5q0 48.12-32.268 80.31-32.267 32.19-80.5 32.19ZM768 407v-93h-92v-72.5h93V150h72v92.5h93V315h-94v92h-72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAPhotoFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/add_a_photo_FILL1_wght700_GRAD200_opsz48.d14e1cdae0fda2b61a6334c417a2015c.svg";
export { ForwardRef as ReactComponent };